import React, { PropTypes, Component } from 'react';
import DatePicker from "react-datepicker";
import moment from "moment";
const log = require('debug')('app:gis-map:point-detail');
import { localize } from 'linksoft';
const Resx = localize('App', 'Common');


export const DisplayModeOption = {
    NAME: 'Name',
    ALT_DESCRIPTION: 'AlternativeDescription'
}

const DateFilterOption = {
    TODAY: 'Today',
    WEEK: 'Week',
    MONTH: 'Month',
    CUSTOM: 'Custom'
}

//not used anymore
class Filter extends Component {

    static propTypes = {
        projects: PropTypes.array.isRequired,
        filterClosed: PropTypes.bool.isRequired,
        filterData: PropTypes.func.isRequired,
        filterAuxDrawings: PropTypes.func.isRequired,
        filterDataByDates: PropTypes.func.isRequired,
        toggleFilter: PropTypes.func.isRequired,
        displayModeChanged: PropTypes.func.isRequired,
        linkedProjectsCount: PropTypes.number.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = { dateFrom: null, dateTo: null, option: DateFilterOption.TODAY, selectedDisplayMode: DisplayModeOption.NAME };
    }

    onDisplayModeChanged = (e) => {
        this.setState({
            selectedDisplayMode: e.currentTarget.value
        });
    }

    onDateOptionChanged = (e) => {
        this.setState({
            option: e.currentTarget.value
        });
    }

    filterByDates = () => {
        const { filterDataByDates } = this.props;
        const { dateFrom, dateTo, option } = this.state;
        let dates = [];
        const today = moment().toString();
        switch (option) {
            case DateFilterOption.TODAY:
                dates = [moment(today), moment(today)];
                break;
            case DateFilterOption.WEEK:
                dates = [moment(today).subtract(1, 'weeks'), moment(today)];
                break;
            case DateFilterOption.MONTH:
                dates = [moment(today).subtract(1, 'months'), moment(today)];
                break;
            case DateFilterOption.CUSTOM:
                dates = [dateFrom, dateTo];
                break;
        }

        filterDataByDates(...dates);
    }

    renderProfiles = (project, axis, chapter, filterData) => {
        return chapter.profiles.map((profile) => {
            return (
                <div key={profile.id}>
                    <span className={"collapsible-filter " + (((profile.line && profile.line.alert) || (profile.points && profile.points.some(x => x.alert))) ? 'li-alert gis-point-pulse' : 'li')}></span>
                    <input type="checkbox" checked={profile.visible} id={'profile_' + profile.id} onChange={() => filterData(!profile.visible, project.id, axis.id, chapter.id, profile.id)} />
                    <label htmlFor={'profile_' + profile.id}>{profile.name}</label>
                </div>
            )
        })
    }

    renderChapters = (project, axis, filterData) => {
        return axis.chapters.map((chapter) => {
            return (
                <div key={chapter.id}>
                    <span className="collapsible-filter collapsed" data-toggle="collapse" data-target={`#filter-profiles-${chapter.id}`} aria-expanded="false" aria-controls="filter-profiles" />
                    <input type="checkbox" checked={chapter.visible} id={'chapter_' + chapter.id} onChange={() => filterData(!chapter.visible, project.id, axis.id, chapter.id)} />
                    <label htmlFor={'chapter_' + chapter.id}>{chapter.name}</label>
                    <div id={`filter-profiles-${chapter.id}`} className="collapse collapsible-content">
                        {this.renderProfiles(project, axis, chapter, filterData)}
                    </div>
                </div>
            )
        })      
    }

    renderAxes = (project, filterData) => {
        return project.axes.map((axis) => {
            return (
                <div key={axis.id}>
                    <span className="collapsible-filter collapsed" data-toggle="collapse" data-target={`#filter-chapters-${axis.id}`} aria-expanded="false" />
                    <input type="checkbox" checked={axis.visible} id={'axis' + axis.id} onChange={() => filterData(!axis.visible, project.id, axis.id)} />
                    <label htmlFor={'axis' + axis.id}>{axis.name}</label>
                    <div id={`filter-chapters-${axis.id}`} className="collapse collapsible-content">
                        <div key={'axis' + axis.id + 'excavations'}>
                            <span className={"collapsible-filter li"}></span>
                            <input type="checkbox" checked={axis.showExcavations} id={'axis' + axis.id + 'excavations'} onChange={() => filterData(!axis.showExcavations, project.id, axis.id, -1)} />
                            <label htmlFor={'axis' + axis.id + 'excavations'}>{Resx.App.Excavations}, {Resx.App.Chainage}</label>
                        </div>
                        {this.renderChapters(project, axis, filterData)}
                    </div>
                </div>
            )
        })
    }

    renderAuxDrawings = (project, filterAuxDrawings) => {
        return project.auxDrawings.map((drawing) => {
            return (
                <div key={'auxdrawing' + drawing.id}>
                    <span className={'collapsible-filter li'}></span>
                    <input type="checkbox" checked={drawing.visible} id={'auxdrawing' + drawing.id} onChange={() => filterAuxDrawings(!drawing.visible, project.id, drawing.id)} />
                    <label htmlFor={'auxdrawing' + drawing.id}>{drawing.name}</label>
                </div>
            )
        })
    }

    renderProjects = (projects, filterData, filterAuxDrawings) => {
        return projects.map((project) => {
            return (
                <div key={project.id} id="filter-projects">
                    <span className="collapsible-filter collapsed" data-toggle="collapse" data-target={`#filter-axes-${project.id}`} aria-expanded="false" />
                    <input type="checkbox" checked={project.visible} id={'project' + project.id} onChange={() => filterData(!project.visible, project.id)} />
                    <label htmlFor={'project' + project.id}>{project.name}</label>
                    <div id={`filter-axes-${project.id}`} className="collapse collapsible-content">
                        <div key={'project' + project.id + 'auxdrawings'}>
                            <span className="collapsible-filter collapsed" data-toggle="collapse" data-target={`#filter-auxdrawings-${project.id}`} aria-expanded="false" />
                            <input type="checkbox" checked={project.auxDrawingsVisible} id={'project' + project.id + 'auxdrawings'} onChange={() => filterAuxDrawings(!project.auxDrawingsVisible, project.id)} />
                            <label htmlFor={'project' + project.id + 'auxdrawings'}>{Resx.App.AuxiliaryDrawings}</label>
                            <div id={`filter-auxdrawings-${project.id}`} className="collapse collapsible-content">
                                {this.renderAuxDrawings(project, filterAuxDrawings)}
                            </div>
                        </div>
                        {this.renderAxes(project, filterData)}
                    </div>
                </div>
            )
        })
    }

    renderLoading = (projects, linkedProjectsCount) => {
      return (projects.length <= 1 && linkedProjectsCount > 0)
          ? (
             <div>{Resx.App.GisProjectsLoading}</div>
          )
          : ""
    }

    renderFilterDisplayMode = (selectedDisplayMode, displayModeChanged) => {
        return (
            <fieldset>
                <legend>{Resx.App.Gis_DisplayModeTitle}</legend>
                <label>
                    <input type="radio" name="selectedDisplayMode" value={DisplayModeOption.NAME} checked={selectedDisplayMode === DisplayModeOption.NAME} onChange={this.onDisplayModeChanged} /> {Resx.App[`DisplayModeOption_RefNum`]}
                </label>
                <label>
                    <input type="radio" name="selectedDisplayMode" value={DisplayModeOption.ALT_DESCRIPTION} checked={selectedDisplayMode === DisplayModeOption.ALT_DESCRIPTION} onChange={this.onDisplayModeChanged} /> {Resx.App[`DisplayModeOption_AltDesc`]}
                </label>
                <button title={Resx.Common.Apply} className={"btn btn-primary btn-sm space-t-10"} onClick={() => displayModeChanged(selectedDisplayMode)}>{Resx.Common.Apply}</button>
            </fieldset>
        )
    }

    renderDateFilterOptions = (dateFilterOptions, dateFrom, dateTo, option) => {
        return dateFilterOptions.map((opt) => {
            const value = DateFilterOption[opt];
            return (
                <label key={`date-filter-${opt}`}>
                    <input type="radio" key={"date-filter-" + "i"} name="option" value={value} checked={value === option} onChange={this.onDateOptionChanged} /> {Resx.App[`DateFilterOption_${value}`]}
                    {value === DateFilterOption.CUSTOM ?
                        <span>
                            <DatePicker selected={dateFrom} dateFormat="DD/MM/YYYY" onChange={date => this.setState({ dateFrom: date, dateTo: dateTo, option: DateFilterOption.CUSTOM })} />
                            {"-"}
                            <DatePicker selected={dateTo} dateFormat="DD/MM/YYYY" onChange={date => this.setState({ dateFrom: dateFrom, dateTo: date, option: DateFilterOption.CUSTOM })} />
                        </span> : ""
                    }
                </label>
            )
        })
    }

    render() {
        const { projects, filterData, filterAuxDrawings, filterClosed, toggleFilter, displayModeChanged, linkedProjectsCount } = this.props;
        const { dateFrom, dateTo, option, selectedDisplayMode } = this.state;

        return (
            <div className="gis-filter">
                <div className={"gis-filter-opener" + (filterClosed ? "" : " open")} onClick={() => toggleFilter(filterClosed)}><i className="fa fa-filter" aria-hidden="true"></i></div>
                {!filterClosed && <div className="gis-filter-content">
                    <div className="gis-filter-date">
                        {this.renderFilterDisplayMode(selectedDisplayMode, displayModeChanged)}
                    </div>
                    <div className="gis-filter-date">
                        <fieldset>
                            <legend>{Resx.App.Gis_DateFilterTitle}</legend>
                            {this.renderDateFilterOptions(Object.keys(DateFilterOption), dateFrom, dateTo, option)}
                            <button title={Resx.Common.Filter} className={"btn btn-primary btn-sm space-t-10"} onClick={() => this.filterByDates()}>{Resx.Common.Filter}</button>
                        </fieldset>
                    </div>
                    <div>
                        {this.renderProjects(projects, filterData, filterAuxDrawings)}
                        {this.renderLoading(projects, linkedProjectsCount)}
                    </div>
                </div>
                }
            </div>
        )
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./App/components/modules/gis-map/filter.js